import { svg } from "lit";
const icon = svg `<path d="M2.70184 16.2467L7.20499 10.0801H11.2098L16.4549 3.70998V16.2467H2.70184ZM3.57197 12.1522L2.7002 11.5176L5.74507 7.33654H9.75788L13.1778 3.1875L14.0191 3.8814L10.2739 8.41985H6.28672L3.57197 12.1522ZM4.85082 15.1634H15.3717V6.74675L11.7258 11.1634H7.74665L4.85082 15.1634Z" fill="currentColor"/>`;
export default icon;
